import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useBlockContext } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Impact Figures Inner Card",
}

export default defineBlock("section/impact-figures-inner-card", (props) => {
  const info = useBlockContext()
  const index = info?.index || 0

  return (
    <Appear
      delay={(index + 1) * 50}
      className={cn(
        "impact-figures-inner-card relative w-full rounded-md bg-offWhite text-charcoal p-5 h-full [&_p]:type-body-m-mobile [&_p]:text-grey-2 [&_p>strong]:text-charcoal [&_h5]:mt-4 [&_h2]:normal-case [&_h2]:!-mb-3 [&_h5]:!-mb-2",
        !env.admin && "flex flex-col gap-4",
      )}
    >
      <InnerBlocks
        allowedBlocks={["#inline"]}
        template={[
          ["core/heading", { level: 2, placeholder: "0x" }],
          ["core/paragraph", { placeholder: "Example description" }],
          ["core/heading", { level: 5, placeholder: "Enter a title" }],
          ["core/paragraph", { placeholder: "Enter a description" }],
        ]}
      />

      <div className="absolute right-5 top-5 text-charcoal">
        <svg className="h-8 md:h-6 w-auto" viewBox="0, 0, 28.571, 32">
          <path
            d="M25.237,3.771 C26.328,4.991 27.127,6.499 27.678,8.385 C28.2,10.162 28.49,12.246 28.571,14.75 L28.571,17.25 C28.493,19.757 28.2,21.838 27.678,23.615 C27.124,25.501 26.325,27.009 25.237,28.229 C22.965,30.767 19.382,32 14.286,32 C11.561,32 9.321,31.661 7.443,30.959 C5.616,30.278 4.178,29.279 3.052,27.902 C0.969,25.354 0,21.572 0,15.998 C0,10.424 0.969,6.643 3.055,4.098 C4.181,2.721 5.616,1.722 7.446,1.041 C9.325,0.339 11.565,0 14.289,0 C19.385,0 22.969,1.233 25.24,3.771 L25.237,3.771 z M26.011,23.109 C26.489,21.483 26.756,19.552 26.832,17.205 L26.832,14.791 C26.756,12.445 26.489,10.514 26.011,8.891 C25.536,7.268 24.859,5.984 23.95,4.966 C23.019,3.922 21.833,3.16 20.329,2.632 C18.706,2.062 16.771,1.774 14.289,1.774 C11.807,1.774 9.705,2.087 8.044,2.705 C6.512,3.275 5.317,4.101 4.395,5.231 C3.486,6.342 2.831,7.751 2.394,9.534 C1.957,11.311 1.746,13.427 1.746,16.002 C1.746,18.576 1.957,20.689 2.394,22.469 C2.831,24.252 3.486,25.661 4.395,26.772 C5.32,27.902 6.512,28.728 8.044,29.298 C9.705,29.916 11.904,30.229 14.289,30.229 C16.674,30.229 18.706,29.941 20.329,29.372 C21.833,28.843 23.019,28.081 23.95,27.038 C24.859,26.019 25.536,24.736 26.011,23.112 L26.011,23.109 z"
            fill="currentColor"
          />
        </svg>
        <div className="w-full h-full absolute left-0 top-0 flex items-center justify-center font-mono font-bold text-[0.8em]">
          {(index + 1).toString().padStart(2, "0")}
        </div>
      </div>
    </Appear>
  )
})
